import { GradientMesh } from '@merritrac/shared/components';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '../../lib/auth.js';

import type { ReactElement } from 'react';

interface ProtectedRouteProps {
  children: ReactElement;
}

export function ProtectedRoute({ children }: ProtectedRouteProps): ReactElement {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  const verify = useAuth((s) => s.verify);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    void verify().finally(() => {
      setChecked(true);
    });
  }, []);

  if (!checked) {
    return (
      <div className="min-h-screen relative flex items-center justify-center">
        <GradientMesh />
        <div className="flex flex-col items-center gap-3 relative z-10">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
